"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var dictionarySettings = {
  buttons: {
    changeButton: "changeButton",
    saveButton: "saveButton",
    photosAgainButton: "photosAgainButton",
    removeButton: "removeButton",
    answersButton: "answersButton",
    nextButton: "nextButton",
    editButton: "editButton",
    sendButton: "sendButton",
    downloadButton: "downloadButton",
    backButton: "backButton",
    chooseScenarioButton: "chooseScenarioButton",
    addMoreScenariosButton: "addMoreScenariosButton"
  },
  thankYouView: {
    thankYouText: "thankYouText",
    allWeNeedText: "allWeNeedText",
    photosAgainButton: "photosAgainButton",
    appointmentDescritption: "appointmentDescritption",
    reasonLabel: "reasonLabel",
    reasonPlaceholder: "reasonPlaceholder",
    expectationsLabel: "expectationsLabel",
    expectationsPlaceholder: "expectationsPlaceholder",
    saveButton: "saveButton"
  },
  listOverview: {
    overviewHeadline: "overviewHeadline",
    chooseScenarioHeadline: "chooseScenarioHeadline",
    chooseOneMoreScenarioHeadline: "chooseOneMoreScenarioHeadline"
  },
  answerOverview: {
    situationNumber: "situationNumber",
    editButton: "editButton",
    personalDescription: "personalDescription",
    deleteScenarioConfirmation: "deleteScenarioConfirmation"
  },
  reviewAnswersView: {
    yourAnswersHeadline: "yourAnswersHeadline",
    yourAnswersDescription: "yourAnswersDescription",
    personalNotesHeadline: "personalNotesHeadline",
    reasonLabel: "reasonLabel",
    reasonPlaceholder: "reasonPlaceholder",
    expectationsLabel: "expectationsLabel",
    expectationsPlaceholder: "expectationsPlaceholder",
    sendButton: "sendButton",
    downloadButton: "downloadButton"
  },
  audiologistEmailFormView: {
    emailSendHeadline: "emailSendHeadline",
    emailLabel: "emailLabel",
    emailPlaceholder: "emailPlaceholder",
    hcpEmail: "hcpEmail",
    hcpPlaceholder: "hcpPlaceholder",
    nameLabel: "nameLabel",
    namePlaceholder: "namePlaceholder",
    sendButton: "sendButton",
    conditions: ["condition-1", "condition-2", "condition-3"]
  },
  downloadingAnswersView: {
    downloadHeadline: "downloadHeadline",
    downloadDescription: "downloadDescription"
  },
  audiologistEmailThankYouView: {
    emailSendHeadline: "emailSendHeadline",
    emailSentDescription: "emailSentDescription"
  },
  scenarioFormView: {
    imageLabel: "imageLabel",
    scenarioLabel: "scenarioLabel",
    scenarioPlaceholder: "scenarioPlaceholder",
    saveButton: "saveButton",
    changeButton: "changeButton"
  },
  savedView: {
    savedScenario: "savedScenario",
    nextButton: "nextButton",
    answersButton: "answersButton"
  },
  features: {
    pdfName: "pdfName",
    validationMessage: "validationMessage"
  }
};
var _default = dictionarySettings;
exports["default"] = _default;